import { useState, useEffect } from "react";
import api from "../lib/api";
import { mediaUrl } from "../lib/mediaUrl";
import { Camera, Star, MapPin } from "lucide-react";

// Historique des photos de sacs scellés — profil livreur Nold Go.
// Le livreur peut consulter tous ses envois de photos pour asseoir sa crédibilité.
export function BagPhotosHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoom, setZoom] = useState(null); // url de la photo affichée en grand

  useEffect(() => {
    let ok = true;
    api.get("/driver/bag-photos")
      .then((r) => { if (ok) setItems(r.data.items || []); })
      .catch(() => {})
      .finally(() => { if (ok) setLoading(false); });
    return () => { ok = false; };
  }, []);

  if (loading) return null;
  if (items.length === 0) return null;

  return (
    <div className="mt-4 bg-white rounded-3xl border border-[#E2DFD8] p-6" data-testid="bag-photos-history">
      <h3 className="font-head font-bold text-base flex items-center gap-2">
        <Camera className="w-5 h-5 text-[#F26419]" /> Photos de sacs scellés <span className="text-xs font-normal text-[#75807A]">({items.length})</span>
      </h3>
      <p className="text-xs text-[#75807A] mt-1">Chaque photo renforce votre réputation auprès des restaurants partenaires.</p>
      <div className="mt-4 grid grid-cols-3 sm:grid-cols-4 gap-2">
        {items.map((r) => (
          <button key={r.id} data-testid={`bag-photo-thumb-${r.id}`}
            onClick={() => setZoom(r)}
            className="group relative rounded-xl overflow-hidden border border-[#E2DFD8] hover:border-[#F26419] transition-colors bg-[#F7F3EC]">
            <img src={mediaUrl(r.bag_photo_url)} alt="Sac scellé" className="w-full h-24 object-cover" />
            {r.food_rating && (
              <span className="absolute top-1 right-1 inline-flex items-center gap-0.5 rounded-full bg-[#16a34a] text-white text-[10px] font-bold px-1.5 py-0.5">
                <Star className="w-2.5 h-2.5 fill-white" /> {r.food_rating}
              </span>
            )}
            {r.restaurant_name && (
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-1">
                <div className="text-white text-[10px] font-semibold truncate">{r.restaurant_name}</div>
              </div>
            )}
          </button>
        ))}
      </div>
      {zoom && (
        <div className="fixed inset-0 z-[1000] bg-black/80 flex items-center justify-center p-4" onClick={() => setZoom(null)} data-testid="bag-photo-zoom">
          <div className="bg-white rounded-2xl overflow-hidden max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <img src={mediaUrl(zoom.bag_photo_url)} alt="Sac scellé" className="w-full h-auto object-contain max-h-[70vh]" />
            <div className="p-4 space-y-1">
              {zoom.restaurant_name && <div className="font-semibold text-[#16a34a] flex items-center gap-1.5">🍔 {zoom.restaurant_name}</div>}
              <div className="text-xs text-[#75807A] flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {zoom.pickup} → {zoom.destination}</div>
              {zoom.food_rating && (
                <div className="flex items-center gap-1 text-xs text-[#16a34a]">
                  Note client : {[1,2,3,4,5].map((s) => <Star key={s} className={`w-3.5 h-3.5 ${zoom.food_rating >= s ? "fill-[#16a34a] text-[#16a34a]" : "text-[#E2DFD8]"}`} />)}
                </div>
              )}
              <button data-testid="bag-photo-zoom-close" onClick={() => setZoom(null)} className="mt-2 w-full h-10 rounded-xl bg-[#1A1A1A] text-white font-bold text-sm">Fermer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
